<template>
  <div>

    <h1>State</h1>

    <p v-if="!currentState" v-html="intro"></p>

    <template v-if="currentState">
      <a href="/vi-eligibility-criteria/state/">Back to State list</a>
      <Single :stateName="currentState" :data="currentStateData" :dict="groupedFields" :groups="groups" :glabels="glabels"></Single>
    </template>

    <ul  v-else class="list-group">
      <li  v-for="(state, slug) in stateSlugs" class="list-group-item">
        <a :href="'/vi-eligibility-criteria/state/' + slug" class="list-group-item-action">{{ state }}</a>
      </li>
    </ul>

    <p v-html="footer"></p>

  </div>
</template>

<script>
import { stringToSlug, simpleGroupBy } from "../lib/util.js";
import Single from '../components/Single.vue';

let intro = `
<p>Welcome to the "Browse by State" page. Here, you can access our database to see how different states and territories under the Individuals with Disabilities Education Act (IDEA) define and support students who are blind, have low vision, or are deafblind. This resource provides the most current information available to us on eligibility criteria and educational services.</p>

<dl>
  <dt>Federal Definitions:</dt>
  <dd>Visual Impairment Including Blindness (VI)
  Sec. 300.8 (c) (13): This refers to an impairment in vision that, even with correction, adversely affects a child’s educational performance, encompassing both partial sight and blindness.</dd>

  <dt>Deaf-Blindness (DB):</dt>
  <dd>Sec. 300.8 (c) (2)*: Deaf-blindness involves simultaneous visual and auditory impairments, which cause severe communication and developmental challenges that cannot be addressed in programs solely for children with blindness or deafness.</dd>
</dl>

<p>You can also download the OSEP memo addressing Special Education eligibility for students with visual impairments that may provide more guidelines and resources
here: <a href="https://sites.ed.gov/idea/files/letter-on-visual-impairment-5-22-17.pdf">https://sites.ed.gov/idea/files/letter-on-visual-impairment-5-22-17.pdf</a>
</p>`;


let footer = `
Please note that while we strive to keep our data up to date, there may be instances where changes in legislation or policy are not immediately reflected in our database. This page will guide you in understanding how these definitions are applied across states, helping you find suitable educational support for children with these disabilities.`;

export default {
  props: ["data", "dict", "stateName"],
  data() {
    return {
      intro,
      footer,
    };
  },
  components: {
    Single,
  },

  computed: {
    stateSlugs() {
      return Object.fromEntries(
        this.dict.states.map((state) => [stringToSlug(state), state])
      );
    },
    currentState() {
      return this.stateSlugs?.[this.stateName] ?? null;
    },
    currentStateData() {
      return this.data.find(data => data.state === this.currentState);
    },

    /** map backend data into useful structure for frontend */
    fieldsForDict() {
      return this.dict.dict.map((def) => ({
        coding: def.field_column_type === 'bit' ? { 0: 'No', 1: 'Yes' } : Object.fromEntries(JSON.parse(def.field_options).map(opt => [opt.value, opt.label])),
        section_slug: stringToSlug(def.section_title),
        section_title: def.section_title,
        description: def.field_config_hint,
        label: def.field_title,
        name: def.field_config_extended_label,
        notes: def.field_config_help_text,
      }));
    },

    groupedFields() {
      return simpleGroupBy(this.fieldsForDict, "section_slug");
    },
    groups() {
      return simpleGroupBy(this.fieldsForDict, "section_slug", 'None', (def) => def.label);
    },

    glabels() {
      return Object.fromEntries(Object.keys(this.groupedFields).map(key => [key, this.groupedFields[key][0].section_title]));
    },



  },
};
</script>

<style></style>